import { KavaPageTypes } from './kava-page-types';
import { routesPaths } from './routes-paths';

export const pageInfo = {
  [routesPaths.LOGIN]: {
    name: 'kpfLogin',
    type: KavaPageTypes.Login,
  },
  [routesPaths.FORGOT_PASSWORD]: {
    name: 'kpfForgotPassword',
    type: KavaPageTypes.Login,
  },
  [routesPaths.SET_PASSWORD]: {
    name: 'kpfSetPassword',
    type: KavaPageTypes.Login,
  },
  [routesPaths.GET_STARTED]: {
    name: 'kpfGetStarted',
    type: KavaPageTypes.Registration,
  },
  [routesPaths.GET_STARTED_2]: {
    name: 'kpfGetStarted',
    type: KavaPageTypes.Registration,
  },
  [routesPaths.CREATE_ACCOUNT_EXTENDED]: {
    name: 'kpfCreateAccountExtended',
    type: KavaPageTypes.Registration,
  },
  [routesPaths.CREATE_ACCOUNT_BASE]: {
    name: 'kpfCreateAccountBase',
    type: KavaPageTypes.Registration,
  },
  [routesPaths.BUILD_PLAN]: {
    name: 'kpfBuildYourPlan',
    type: KavaPageTypes.Registration,
  },
  [routesPaths.ABANDONED_CHECKOUT]: {
    name: 'kpfCheckout',
    type: KavaPageTypes.Registration,
  },
  [routesPaths.CHECKOUT]: {
    name: 'kpfCheckout',
    type: KavaPageTypes.Registration,
  },
  [routesPaths.MANAGEMENT_OVERVIEW]: {
    name: 'kpfAccountOverview',
    type: KavaPageTypes.View,
  },
  [routesPaths.MANAGEMENT_BILLING]: {
    name: 'kpfAccountBilling',
    type: KavaPageTypes.View,
  },
  [routesPaths.MANAGEMENT_INVOICE]: {
    name: 'kpfAccountInvoice',
    type: KavaPageTypes.View,
  },
  [routesPaths.VERIFY]: {
    name: 'kpfVerify',
    type: KavaPageTypes.View,
  },
  [routesPaths.LINK_USED]: {
    name: 'kpfLinkUser',
    type: KavaPageTypes.Registration,
  },
  [routesPaths.CONFIRMED]: {
    name: 'kpfConfirmed',
    type: KavaPageTypes.View,
  },
  [routesPaths.PLEASE_WAIT]: {
    name: 'kpfPleaseWait',
    type: KavaPageTypes.Registration,
  },
  [routesPaths.ONE_LAST_STEP]: {
    name: 'kpfOneLastStep',
    type: KavaPageTypes.Registration,
  },
  [routesPaths.ONE_LAST_STEP_2]: {
    name: 'kpfOneLastStep',
    type: KavaPageTypes.Registration,
  },
};
